// variant-image-switcher.js
window.initVariantImageSwitcher = function(opts) {
  try {
    const sectionId = typeof opts === 'object' ? opts.sectionId : opts;
    const imageId = typeof opts === 'object' && opts.imageId ? opts.imageId : 'ProductMainImage';

    const productJsonEl = document.getElementById('ProductJson-' + sectionId);
    if (!productJsonEl) return console.warn("VariantImageSwitcher: brak ProductJson", sectionId);
    const productData = JSON.parse(productJsonEl.textContent);

    const mainImage = document.getElementById(imageId);
    if (!mainImage) return console.warn("VariantImageSwitcher: brak obrazu", imageId);

    function setMainImageSrc(src) {
      if (!src) return;
      mainImage.src = src.split('?')[0];
    }

    function getSelectedOptions() {
      let selected = [];
      const selects = document.querySelectorAll(`#ProductSelect-${sectionId}, .single-option-selector-${sectionId}`);
      selects.forEach(s => selected.push(s.value));

      const radios = document.querySelectorAll(`.swatch-element input[type="radio"]:checked`);
      radios.forEach(r => selected.push(r.value));
      return selected;
    }

    function findVariant() {
      const selected = getSelectedOptions();
      return productData.variants.find(v =>
        v.options.every((opt, i) => opt === selected[i])
      ) || null;
    }

    function onVariantChange() {
      const variant = findVariant();
      if (!variant) return;
      if (variant.featured_image && variant.featured_image.src) setMainImageSrc(variant.featured_image.src);
      else if (productData.featured_image) setMainImageSrc(productData.featured_image.src);
    }

    // nasłuchiwanie selectów
    document.querySelectorAll(`#ProductSelect-${sectionId}, .single-option-selector-${sectionId}`).forEach(sel => {
      sel.addEventListener('change', () => setTimeout(onVariantChange, 0));
    });

    // nasłuchiwanie swatchy
    document.querySelectorAll(`.swatch-element input[type='radio']`).forEach(r => {
      r.addEventListener('change', () => setTimeout(onVariantChange, 0));
    });

    setTimeout(onVariantChange, 50);
  } catch (e) {
    console.error("VariantImageSwitcher błąd:", e);
  }
};
